module.exports = "pegasus_template/assets/background-patterns/theme3_theme.gif";